import React, {useLayoutEffect, useRef} from 'react';

const options = {
	userName: 'sparkcreative',
	formHash: 'x1j6l70k0k31ajt',
	autoResize: true,
	height: '555',
	"async": true,
	host: 'wufoo.com',
	header: 'hide',
	ssl: true
};

const includeScript = src => {
	return (new Promise(resolve => {
		let s = document.createElement('script');
		s.addEventListener('load', () => resolve());
		s.src = src;
		document.body.insertBefore(s, document.body.children[0]);
	}));
};

const ContactForm = ({gutenberg:{isEditor}}) => {
	if (isEditor) return "Contact Form";

	const ref = useRef();

	useLayoutEffect(() => {
		if (!ref.current) return;
		includeScript('//secure.wufoo.com/scripts/embed/form.js').then(() => {
			try {
				window[options.formHash] = new WufooForm();
				window[options.formHash].initialize(options);
				window[options.formHash].display();
			} catch (e) {
				console.log("Failed to load wufoo form:", e, options);
			}
		});
	}, [ref.current]);

	return <div id={`wufoo-${options.formHash}`} ref={ref} />;
};

ContactForm.title = 'Contact Form';
ContactForm.category = 'widgets';
ContactForm.icon = 'email-alt';

export default ContactForm;

